module.exports = __webpack_public_path__ + "static/media/kellihers.1bc91c7e.png";